
// app.js
import React, { useState } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom"; // Added Navigate
import { LinkedInCallback } from 'react-linkedin-login-oauth2';

import { useChatbots } from './contexts/ChatbotContext';
import Layout from './components/Layout';
import ChatbotLayout from './components/ChatbotLayout';
import FinanceCRMGate from './components/FinanceCRMGate';
import Resubscribe from './pages/creator-panel/Resubscribe';

// import Sidebar from './components/Sidebar'; // Sidebar is part of Layout
import './App.css';
import './assets/css/bootstrap.min.css';
import './assets/css/app.css';
import './assets/css/custom.css';

// --- Page Imports (all your pages) ---
import MyChatbots from './pages/creator-panel/MyChatbots'; // Corrected import name
import ChatbotCreationSteps from './pages/creator-panel/Steps/ChatbotCreationSteps.js';
import Dashboard from './pages/creator-panel/Dashboard/Dashboard.js';
import AddDocuments from './pages/creator-panel/Documents/AddDocuments';
import Scraper from './pages/creator-panel/WebsiteLinks/Scraper.js';
import WebsiteConfigurations from './pages/creator-panel/WebsiteConfigurations';
import CompanySettingsPage from './pages/creator-panel/CompanySettingsPage';
// import AudioLanguage from './pages/creator-panel/AudioLanguage/AddAudioLanguage'; // Assuming ListAudioLanguage is used
import ListAudioLanguage from './pages/creator-panel/AudioLanguage/ListAudioLanguage.js';
import ChatHistory from './pages/creator-panel/ChatHistory';
import ChatAnalysis from './pages/creator-panel/ChatAnalysis';
import ChoosePosition from './pages/creator-panel/ChoosePosition';
import AvatarSettings from './pages/creator-panel/AvatarSettings';
import Analytics from './pages/creator-panel/Analytics';
import UserProfile from './pages/creator-panel/UserProfile';
import Test from './pages/creator-panel/Test';
import SignIn from './pages/creator-panel/SignIn';
import SignUp from './pages/creator-panel/SignUp';
import ForgotPassword from './pages/creator-panel/ForgotPassword.js';
import ColorSettings from './pages/creator-panel/ColorSettings';
import ImproveQuestions from './pages/creator-panel/QuestionImprovement/AddImproveQuestions';
import ImproveAnswer from './pages/creator-panel/AnswerImprovement/ImproveAnswer';
import LogoutPage from './pages/creator-panel/LogoutPage';
import Pronoun from './pages/creator-panel/Pronoun/AddPronoun';
import AddSitemap from './pages/creator-panel/Sitemaps/AddSitemap';
import ListUserFeedback from './pages/creator-panel/UserFeedback.js';
import Help from './info-pages/Help.js';
import Support from './info-pages/Support.js';
import Privacy from './info-pages/Privacy.js';
import Terms from './info-pages/Terms.js';
import Billing from './pages/creator-panel/Billing/Billing.js';
import InvoiceHistory from './pages/creator-panel/Billing/InvoiceHistory.js';
import Pricing from './pages/creator-panel/Billing/Pricing.js';
import SubscriptionHistory from './pages/creator-panel/Billing/SubscriptionHistory.js';
import LiveChatbot from './pages/creator-panel/Dashboard/Live.js';
// import LLMSettings from './pages/creator-panel/LLMSettings.js'; // Likely part of ChatbotSettings
import ChatbotSettings from './pages/creator-panel/ChatbotSettings/ChatbotSettings.js';
// import Prompt from './pages/creator-panel/ChatbotSettings/Prompt.js'; // Likely part of ChatbotSettings
import AddImage from './pages/creator-panel/Image/AddImage.js';
import ListMonetize from './pages/creator-panel/Monetize/ListMonetize.js';
import VoiceTranscription from './pages/creator-panel/VoiceRecording/Recording.js';
import KnowledgeData from './pages/creator-panel/Knowledge/Knowledge.js';
import VerifiedEmail from './pages/creator-panel/Verify.js';
import SignUpSteps from './pages/creator-panel/Steps/SignUpSteps.js';
import PaymentSuccess from './pages/creator-panel/Billing/PaymentSuccess.js';
import ResetPasswordPage from './pages/creator-panel/ResetPasswordPage.js';
import StudentRegistration from './pages/creator-panel/StudentRegistration.js';
import CustomerInvitationPage from './pages/customer-panel/customer-invitation-page/CustomerInvitationPage.js';
import ListExceptionLog from './pages/creator-panel/ExceptionLog/ListExceptionLog.js';
import Channels from './pages/creator-panel/Channels/Channels.js';
import WhatsappChannel from './pages/creator-panel/Channels/Whatsapp/WhatsappChannel.js';
import BulkWhatsappSenderChannel from './pages/creator-panel/Channels/Whatsapp/BulkWhatsappSenderChannel.js';
import Connectors from './pages/creator-panel/Connector/Connectors.js';
import DrivesLandingPage from './pages/creator-panel/Connector/DrivesLandingPage.js';
import GoogleDriveConnector from './pages/creator-panel/Connector/GoogleDrive/GoogleDriveConnector.js';
import GoogleReviewsConnector from './pages/creator-panel/Connector/GoogleReviews/GoogleReviewsConnector.js';
import ReviewsAnalytics from './pages/creator-panel/Connector/GoogleReviews/ReviewsAnalytics.js';
import OneDriveConnector from './pages/creator-panel/Connector/OneDrive/OneDriveConnector.js';
import SmsBotConnector from './pages/creator-panel/Connector/SmsBotConnector.js';
import InstagramConnector from './pages/creator-panel/Connector/Instagram/InstagramConnector.js';
import ServiceNowConnector from './pages/creator-panel/Connector/ServiceNow/ServiceNowConnector';
import PrayerTimingConnector from './pages/creator-panel/Connector/PrayerTiming/PrayerTimingConnector';
import FactTablesPage from './pages/creator-panel/FactTables/FactTablesPage.js';
import KnowledgeGraphPage from './pages/creator-panel/KnowledgeGraph/KnowledgeGraphPage.js';

import Campaigns from './pages/creator-panel/Campaigns/Campaigns.js';
import GmailConnector from './pages/creator-panel/Campaigns/Gmail/GmailConnector.js';
import OutlookConnector from './pages/creator-panel/Campaigns/Outlook/OutlookConnector';
import SmsManagement from './pages/creator-panel/Campaigns/Sms/SmsManagement';
import LeadConnector from './pages/creator-panel/Campaigns/Lead/LeadConnector.js';

// SurveyGenie Imports
import SurveyDashboard from './pages/creator-panel/Campaigns/SurveyGenie/SurveyDashboard';
import SurveyBuilder from './pages/creator-panel/Campaigns/SurveyGenie/SurveyBuilder';
import SurveyResponses from './pages/creator-panel/Campaigns/SurveyGenie/SurveyResponses';
import SurveyAnalytics from './pages/creator-panel/Campaigns/SurveyGenie/SurveyAnalytics';
import SurveyDistribution from './pages/creator-panel/Campaigns/SurveyGenie/SurveyDistribution';
import QuestionBank from './pages/creator-panel/Campaigns/SurveyGenie/QuestionBank';
import PanelistManagement from './pages/creator-panel/Campaigns/SurveyGenie/PanelistManagement';
import PublicSurveyForm from './pages/creator-panel/Public/SurveyGenie/PublicSurveyForm.js';
import SurveyEmailWizard from './pages/creator-panel/Campaigns/SurveyGenie/SurveyEmailWizard';
import SurveyTextAnalysis from './pages/creator-panel/Campaigns/SurveyGenie/SurveyTextAnalysis';
import DataCleaningDashboard from './pages/creator-panel/Campaigns/SurveyGenie/DataCleaningDashboard.js';
import CleaningRulesBuilder from './pages/creator-panel/Campaigns/SurveyGenie/CleaningRulesBuilder.js';
import SurveySmsWizard from './pages/creator-panel/Campaigns/SurveyGenie/SurveySmsWizard';
import SurveyDocuments from './pages/creator-panel/Campaigns/SurveyGenie/SurveyDocuments';
import SurveyFAQs from './pages/creator-panel/Campaigns/SurveyGenie/SurveyFAQs';

import Agents from './pages/creator-panel/Agents/Agents.js';
import GoogleCalendarAgents from './pages/creator-panel/Agents/GoogleCalendar/GoogleCalendarAgents.js';
import MySqlAgents from './pages/creator-panel/Agents/MySQL/MySQLAgents.js';

// Customer Panel imports
import CustomerDashboard from './pages/customer-panel/CustomerDashboard';

// Customer Panel - Live Conversations
import LiveConversationsPage from './pages/customer-panel/live-conversations/LiveConversationsPage';
import LiveChatHistoryPage from './pages/customer-panel/live-conversations/LiveChatHistoryPage';
import AgentSpacePage from './pages/customer-panel/live-conversations/AgentSpacePage';
import SudoProfilePage from './pages/customer-panel/live-conversations/SudoProfilePage';

// Customer Panel - Chat
import ChatPage from './pages/customer-panel/chat/ChatPage';
import ChatHistoryPage from './pages/customer-panel/chat/ChatHistoryPage';

// Customer Panel - Documents & Signatures
import DocumentsPage from './pages/customer-panel/documents/DocumentsPage';
import UserDocumentsPage from './pages/customer-panel/documents/UserDocumentsPage';
import SignaturesPage from './pages/customer-panel/signatures/SignaturesPage';
import SignDocumentPage from './pages/customer-panel/signatures/SignDocumentPage';
import GuestSignPage from './pages/customer-panel/signatures/GuestSignPage';

// Customer Panel - LMS (Courses, Certificates, Achievements)
import CoursesPage from './pages/customer-panel/courses/CoursesPage';
import CourseDetailPage from './pages/customer-panel/courses/CourseDetailPage';
import MyCoursesPage from './pages/customer-panel/courses/MyCoursesPage';
import CertificatesPage from './pages/customer-panel/certificates/CertificatesPage';
import CertificateDetailPage from './pages/customer-panel/certificates/CertificateDetailPage';
import AchievementsPage from './pages/customer-panel/achievements/AchievementsPage';
import LeaderboardPage from './pages/customer-panel/leaderboard/LeaderboardPage';
import EnrollmentsPage from './pages/customer-panel/enrollments/EnrollmentsPage';

// Customer Panel - Core Pages
import ProfilePage from './pages/customer-panel/profile/ProfilePage';
import UsersPage from './pages/customer-panel/users/UsersPage';
import RequestsPage from './pages/customer-panel/requests/RequestsPage';
import InvoicesPage from './pages/customer-panel/invoices/InvoicesPage';
import InvoiceDetailPage from './pages/customer-panel/invoices/InvoiceDetailPage';
import FeedbackPage from './pages/customer-panel/feedback/FeedbackPage';
import NotificationsPage from './pages/customer-panel/notifications/NotificationsPage';
import RemindersPage from './pages/customer-panel/reminders/RemindersPage';
import CreatorNotificationsPage from './pages/creator-panel/notifications/NotificationsPage';
import CreatorRemindersPage from './pages/creator-panel/reminders/RemindersPage';
import StudentNotificationsPage from './pages/student-portal/notifications/NotificationsPage';
import StudentRemindersPage from './pages/student-portal/reminders/RemindersPage';
import CalendarPage from './pages/customer-panel/calendar/CalendarPage';
import PaymentMethodsPage from './pages/customer-panel/payment-methods/PaymentMethodsPage';
import SubscriptionPlanPage from './pages/customer-panel/subscription/SubscriptionPlanPage';
import CustomerSettingsPage from './pages/customer-panel/settings/SettingsPage';
import DriveSettingsPage from './pages/customer-panel/settings/DriveSettingsPage';

// Customer Panel - Appointments
import AppointmentsPage from './pages/customer-panel/appointments/AppointmentsPage';
import AppointmentSettingsPage from './pages/customer-panel/appointments/AppointmentSettingsPage';

// Customer Panel - Support
import SupportTicketsPage from './pages/customer-panel/support/SupportTicketsPage';
import CreateTicketPage from './pages/customer-panel/support/CreateTicketPage';
import TicketDetailPage from './pages/customer-panel/support/TicketDetailPage';

// Customer Panel - Personalize
import PersonalizeDocumentsPage from './pages/customer-panel/personalize/PersonalizeDocumentsPage';
import PersonalizeEmailsPage from './pages/customer-panel/personalize/PersonalizeEmailsPage';
import PersonalizeVoicePage from './pages/customer-panel/personalize/PersonalizeVoicePage';
import PersonalizeWebsitePage from './pages/customer-panel/personalize/PersonalizeWebsitePage';
// Student Portal imports
import StudentDashboard from './pages/student-portal/dashboard/StudentDashboard';
import StMyCoursesPage from './pages/student-portal/courses/MyCoursesPage';
import StCoursesPage from './pages/student-portal/courses/CoursesPage';
import StCourseDetailPage from './pages/student-portal/courses/CourseDetailPage';
import StCertificatesPage from './pages/student-portal/certificates/CertificatesPage';
import StCertificateDetailPage from './pages/student-portal/certificates/CertificateDetailPage';
import StAchievementsPage from './pages/student-portal/achievements/AchievementsPage';
import StLeaderboardPage from './pages/student-portal/leaderboard/LeaderboardPage';
import StEnrollmentsPage from './pages/student-portal/enrollments/EnrollmentsPage';
import StPaymentMethodsPage from './pages/student-portal/payment-methods/PaymentMethodsPage';

// Trading Portal imports
import TradingDashboard from './pages/trading-portal/dashboard/TradingDashboard';
import WatchlistPage from './pages/trading-portal/watchlist/WatchlistPage';
import SymbolDetailPage from './pages/trading-portal/symbol-detail/SymbolDetailPage';
import MarketDataPage from './pages/trading-portal/market-data/MarketDataPage';
import HistoricalDataPage from './pages/trading-portal/historical/HistoricalDataPage';
import IndicatorsPage from './pages/trading-portal/indicators/IndicatorsPage';
import AlertsPage from './pages/trading-portal/alerts/AlertsPage';
import MarketDataIngestionDashboard from './pages/trading-portal/MarketDataIngestion/MarketDataIngestionDashboard';
import StockPriceFeedPage from './pages/trading-portal/MarketDataIngestion/StockPriceFeedPage';
import OptionsChainPage from './pages/trading-portal/MarketDataIngestion/OptionsChainPage';
import OptionsPayoffPage from './pages/trading-portal/MarketDataIngestion/OptionsPayoffPage';
import SingleOptionPayoffPage from './pages/trading-portal/MarketDataIngestion/SingleOptionPayoffPage';
import MacroEconomicPage from './pages/trading-portal/MarketDataIngestion/MacroEconomicPage';
import BitcoinCorrelationPage from './pages/trading-portal/MarketDataIngestion/BitcoinCorrelationPage';
import FedLiquidityEnginePage from './pages/trading-portal/MarketDataIngestion/FedLiquidityEnginePage';
import DataQualityPage from './pages/trading-portal/MarketDataIngestion/DataQualityPage';
import OptionsContractManagementDashboard from './pages/trading-portal/OptionsContractManagement/OptionsContractManagementDashboard';
import ContractDiscoveryPage from './pages/trading-portal/OptionsContractManagement/ContractDiscoveryPage';
import PositionManagementPage from './pages/trading-portal/OptionsContractManagement/PositionManagementPage';
import ExpirationSettlementPage from './pages/trading-portal/OptionsContractManagement/ExpirationSettlementPage';
import StrategyAnalyzerPage from './pages/trading-portal/OptionsContractManagement/StrategyAnalyzerPage';
import AIAnalysisEngineDashboard from './pages/trading-portal/AIAnalysisEngine/AIAnalysisEngineDashboard';
import VolatilityPredictionPage from './pages/trading-portal/AIAnalysisEngine/VolatilityPredictionPage';
import MarketRegimeDetectionPage from './pages/trading-portal/AIAnalysisEngine/MarketRegimeDetectionPage';
import SignalGenerationPage from './pages/trading-portal/AIAnalysisEngine/SignalGenerationPage';
import SentimentAlternativeDataPage from './pages/trading-portal/AIAnalysisEngine/SentimentAlternativeDataPage';
import TradeExecutionDashboard from './pages/trading-portal/TradeExecution/TradeExecutionDashboard';
import OrderManagementPage from './pages/trading-portal/TradeExecution/OrderManagementPage';
import ExecutionAlgorithmsPage from './pages/trading-portal/TradeExecution/ExecutionAlgorithmsPage';
import RiskControlsPage from './pages/trading-portal/TradeExecution/RiskControlsPage';
import PostTradeProcessingPage from './pages/trading-portal/TradeExecution/PostTradeProcessingPage';
import TradingBotPage from './pages/trading-portal/TradeExecution/TradingBotPage';
import VolatilityArbitrageDashboard from './pages/trading-portal/VolatilityArbitrage/VolatilityArbitrageDashboard';
import OpportunityDetectionPage from './pages/trading-portal/VolatilityArbitrage/OpportunityDetectionPage';
import StrategyConstructionPage from './pages/trading-portal/VolatilityArbitrage/StrategyConstructionPage';
import DeltaHedgingPage from './pages/trading-portal/VolatilityArbitrage/DeltaHedgingPage';
import PnlAttributionPage from './pages/trading-portal/VolatilityArbitrage/PnlAttributionPage';

// Finance Portal imports
import FinanceDashboard from './pages/finance-portal/dashboard/FinanceDashboard';
import CategorizationAgent from './pages/finance-portal/agents/CategorizationAgent';
import ReconciliationAgent from './pages/finance-portal/agents/ReconciliationAgent';
import MerchantRPAAgent from './pages/finance-portal/agents/MerchantRPAAgent';
import AnomalyDetectionAgent from './pages/finance-portal/agents/AnomalyDetectionAgent';
import DataQualityAgent from './pages/finance-portal/agents/DataQualityAgent';
import CashFlowForecastingAgent from './pages/finance-portal/agents/CashFlowForecastingAgent';
import BudgetVarianceAgent from './pages/finance-portal/agents/BudgetVarianceAgent';
import VendorSpendAgent from './pages/finance-portal/agents/VendorSpendAgent';
import WorkingCapitalAgent from './pages/finance-portal/agents/WorkingCapitalAgent';
import MonthEndCloseAgent from './pages/finance-portal/agents/MonthEndCloseAgent';
import APAutomationAgent from './pages/finance-portal/agents/APAutomationAgent';
import ARAutomationAgent from './pages/finance-portal/agents/ARAutomationAgent';
import PayrollAutomationAgent from './pages/finance-portal/agents/PayrollAutomationAgent';
import FinanceCommandCenter from './pages/finance-portal/agents/FinanceCommandCenter';
import DocumentIntelligenceAgent from './pages/finance-portal/agents/DocumentIntelligenceAgent';
import FraudDetectionAgent from './pages/finance-portal/agents/FraudDetectionAgent';
import FeedbackLearningAgent from './pages/finance-portal/agents/FeedbackLearningAgent';
import AgentPerformanceAgent from './pages/finance-portal/agents/AgentPerformanceAgent';
import ContinuousImprovementAgent from './pages/finance-portal/agents/ContinuousImprovementAgent';
import AgentHub from './pages/finance-portal/agents/AgentHub';
// Multi-Entity & Multi-Currency
import Entities from './pages/finance-portal/multi-entity/Entities';
import Intercompany from './pages/finance-portal/multi-entity/Intercompany';
import Consolidation from './pages/finance-portal/multi-entity/Consolidation';
import ExchangeRates from './pages/finance-portal/multi-entity/ExchangeRates';
import FXRevaluation from './pages/finance-portal/multi-entity/FXRevaluation';
import SharedServices from './pages/finance-portal/multi-entity/SharedServices';
import PostingMonitor from './pages/finance-portal/posting-monitor/PostingMonitor';
import BankingCenter from './pages/finance-portal/banking/BankingCenter';

// ============ Banking & Cash Management Engine ============
import CashPositionDashboard from './pages/finance-portal/cash-position/CashPositionDashboard';
import CashFlowCalendar from './pages/finance-portal/cash-flow-calendar/CashFlowCalendar';
import MinimumBalanceAlerts from './pages/finance-portal/cash-alerts/MinimumBalanceAlerts';
import TreasurySweepRules from './pages/finance-portal/treasury-sweeps/TreasurySweepRules';
import CashConcentrationReport from './pages/finance-portal/cash-concentration/CashConcentrationReport';
import FloatManagement from './pages/finance-portal/float-management/FloatManagement';
import ReconciliationHub from './pages/finance-portal/bank-reconciliation/ReconciliationHub';
import ReconciliationWorksheet from './pages/finance-portal/bank-reconciliation/ReconciliationWorksheet';
import ReconciliationArchive from './pages/finance-portal/bank-reconciliation/ReconciliationArchive';
import ConnectedAccounts from './pages/finance-portal/connected-accounts/ConnectedAccounts';

// Inventory & Product Management Engine
import InventoryDashboard from './pages/finance-portal/inventory/InventoryDashboard';
import Products from './pages/finance-portal/inventory/Products';
import ProductForm from './pages/finance-portal/inventory/ProductForm';
import ProductDetail from './pages/finance-portal/inventory/ProductDetail';
import Locations from './pages/finance-portal/inventory/Locations';
import InventoryLevels from './pages/finance-portal/inventory/InventoryLevels';
import PurchaseOrders from './pages/finance-portal/inventory/PurchaseOrders';
import POForm from './pages/finance-portal/inventory/POForm';
import PODetail from './pages/finance-portal/inventory/PODetail';
import Receiving from './pages/finance-portal/inventory/Receiving';
import ReceiveForm from './pages/finance-portal/inventory/ReceiveForm';
import InventoryAdjustments from './pages/finance-portal/inventory/InventoryAdjustments';
import ReorderPlanner from './pages/finance-portal/inventory/ReorderPlanner';
import InventoryCounts from './pages/finance-portal/inventory/InventoryCounts';
import LandedCosts from './pages/finance-portal/inventory/LandedCosts';
import LotsSerials from './pages/finance-portal/inventory/LotsSerials';

// Fixed Asset Management Engine
import FixedAssetsDashboard from './pages/finance-portal/fixed-assets/FixedAssetsDashboard';
import FAAssets from './pages/finance-portal/fixed-assets/Assets';
import FAAssetForm from './pages/finance-portal/fixed-assets/AssetForm';
import FAAssetDetail from './pages/finance-portal/fixed-assets/AssetDetail';
import FACategories from './pages/finance-portal/fixed-assets/AssetCategories';
import FADepreciation from './pages/finance-portal/fixed-assets/Depreciation';
import FACIPProjects from './pages/finance-portal/fixed-assets/CIPProjects';
import FADisposals from './pages/finance-portal/fixed-assets/Disposals';
import FAOperations from './pages/finance-portal/fixed-assets/Operations';
import FAReports from './pages/finance-portal/fixed-assets/Reports';
import FAAgent from './pages/finance-portal/fixed-assets/FixedAssetAgent';
import ChartOfAccounts from './pages/finance-portal/chart-of-accounts/ChartOfAccounts';
import JournalEntries from './pages/finance-portal/journal-entries/JournalEntries';
import TrialBalance from './pages/finance-portal/trial-balance/TrialBalance';
import Customers from './pages/finance-portal/customers/Customers';
import CustomerDetail from './pages/finance-portal/customers/CustomerDetail';
import AgentConsole from './pages/finance-portal/agent-console/AgentConsole';
import Invoices from './pages/finance-portal/invoices/Invoices';
import FinanceInvoiceForm from './pages/finance-portal/invoices/InvoiceForm';
import FinanceInvoiceDetail from './pages/finance-portal/invoices/InvoiceDetail';
import FinancePayments from './pages/finance-portal/payments/Payments';
import InvoiceTemplates from './pages/finance-portal/invoice-templates/InvoiceTemplates';
import Estimates from './pages/finance-portal/estimates/Estimates';
import EstimateForm from './pages/finance-portal/estimates/EstimateForm';
import EstimateDetail from './pages/finance-portal/estimates/EstimateDetail';
import CreditMemos from './pages/finance-portal/credit-memos/CreditMemos';
import CreditMemoForm from './pages/finance-portal/credit-memos/CreditMemoForm';
import CreditMemoDetail from './pages/finance-portal/credit-memos/CreditMemoDetail';
import ARAgingReport from './pages/finance-portal/ar-aging/ARAgingReport';
import ARSettings from './pages/finance-portal/settings/ARSettings';
import PaymentLinks from './pages/finance-portal/payment-links/PaymentLinks';
import CashApplication from './pages/finance-portal/cash-application/CashApplication';
import Statements from './pages/finance-portal/statements/Statements';
import StatementDetail from './pages/finance-portal/statements/StatementDetail';
import RecurringInvoices from './pages/finance-portal/recurring-invoices/RecurringInvoices';
import RecurringInvoiceForm from './pages/finance-portal/recurring-invoices/RecurringInvoiceForm';
import RevenueRecognition from './pages/finance-portal/revenue-recognition/RevenueRecognition';
import FinanceCustomerPortal from './pages/finance-portal/customer-portal/FinanceCustomerPortal';
import Transactions from './pages/finance-portal/transactions/Transactions';
import RecurringTransactions from './pages/finance-portal/recurring-transactions/RecurringTransactions';
import BalanceHistory from './pages/finance-portal/balance-history/BalanceHistory';
import CategoryMapping from './pages/finance-portal/category-mapping/CategoryMapping';
import Dimensions from './pages/finance-portal/dimensions/Dimensions';
import JournalMappings from './pages/finance-portal/journal-mappings/JournalMappings';
import RecurringJournals from './pages/finance-portal/recurring-journals/RecurringJournals';
import JournalApprovals from './pages/finance-portal/journal-approvals/JournalApprovals';
import PeriodClosing from './pages/finance-portal/period-closing/PeriodClosing';
import Vendors from './pages/finance-portal/vendors/Vendors';
// Budgeting & FP&A
import Budgets from './pages/finance-portal/budgets/Budgets';
import BudgetDetail from './pages/finance-portal/budgets/BudgetDetail';
import BudgetVariance from './pages/finance-portal/budgets/BudgetVariance';
import ExecutiveDashboard from './pages/finance-portal/executive-dashboard/ExecutiveDashboard';
// Procurement & Supply Chain
import Requisitions from './pages/finance-portal/requisitions/Requisitions';
import RequisitionDetail from './pages/finance-portal/requisitions/RequisitionDetail';
import RequisitionForm from './pages/finance-portal/requisitions/RequisitionForm';
import ProcurementPOs from './pages/finance-portal/procurement-pos/ProcurementPOs';
import ProcurementPODetail from './pages/finance-portal/procurement-pos/ProcurementPODetail';
import ProcurementPOForm from './pages/finance-portal/procurement-pos/ProcurementPOForm';
// Loan & Debt Management
import Loans from './pages/finance-portal/loans/Loans';
import LoanForm from './pages/finance-portal/loans/LoanForm';
import LoanDetail from './pages/finance-portal/loans/LoanDetail';
// Lease Accounting (ASC 842)
import Leases from './pages/finance-portal/leases/Leases';
import LeaseForm from './pages/finance-portal/leases/LeaseForm';
import LeaseDetail from './pages/finance-portal/leases/LeaseDetail';
// Intercompany & Transfer Pricing
import IcNetting from './pages/finance-portal/ic-netting/IcNetting';
import IcNettingDetail from './pages/finance-portal/ic-netting/IcNettingDetail';
import IcReconciliation from './pages/finance-portal/ic-reconciliation/IcReconciliation';
import TpPolicies from './pages/finance-portal/tp-policies/TpPolicies';
import TpPolicyForm from './pages/finance-portal/tp-policies/TpPolicyForm';
import TpAdjustments from './pages/finance-portal/tp-adjustments/TpAdjustments';
import TpAdjustmentForm from './pages/finance-portal/tp-adjustments/TpAdjustmentForm';
import Bills from './pages/finance-portal/bills/Bills';
import BillForm from './pages/finance-portal/bills/BillForm';
import BillPayments from './pages/finance-portal/bill-payments/BillPayments';
import APAgingReport from './pages/finance-portal/ap-aging/APAgingReport';
import Expenses from './pages/finance-portal/expenses/Expenses';
import ExpenseReports from './pages/finance-portal/expense-reports/ExpenseReports';
import ExpenseReportDetail from './pages/finance-portal/expense-reports/ExpenseReportDetail';
import ExpenseCategories from './pages/finance-portal/expense-categories/ExpenseCategories';

import GmailEmailAgent from './pages/creator-panel/Agents/Gmail/GmailEmailAgent';
import OutlookEmailAgent from './pages/creator-panel/Agents/Outlook/OutlookEmailAgent.js';
import AgentSpace from './pages/creator-panel/Agents/AgentSpace/AgentSpace.js';

import LinkedAccounts from './pages/creator-panel/LinkedAccounts/LinkedAccounts.js';

import SummarizationSettings from './pages/creator-panel/SummarizationSettings/SummarizationSettings.js';
import LiveConversation from './pages/creator-panel/LiveConversation/LiveConversation.js';
import ToolsList from './pages/creator-panel/LiveConversation/Tools/ToolsList.js';
import ToolForm from './pages/creator-panel/LiveConversation/Tools/ToolForm.js';
import LivePhoneCall from './pages/creator-panel/LivePhoneCall/LivePhoneCall.js';
import PhoneProviderConfig from './pages/creator-panel/LivePhoneCall/PhoneProviderConfig.js';
import CallRecordings from './pages/creator-panel/LivePhoneCall/CallRecordings.js';
import CallLogsListPage from './pages/creator-panel/CallLogs/CallLogsListPage.js';
import WordpressPlugin from './info-pages/WordPressPlugin.js'; // Assuming this is a public page
import MarketplaceSettings from './pages/creator-panel/Marketplace/MarketplaceSettings.js';

import PaymentsPage from './pages/creator-panel/Payments/PaymentsPage.js'
import PublicPaymentPage from './pages/creator-panel/Public/Payment/PublicPaymentPage';
import PaymentSuccessPage from './pages/creator-panel/Public/Payment/PaymentSuccessPage';
import PaymentCancelPage from './pages/creator-panel/Public/Payment/PaymentCancelPage';
import FinancePublicPayment from './pages/finance-portal/public/FinancePublicPayment';
// Payroll 
import PayrollDashboard from './pages/finance-portal/payroll-dashboard/PayrollDashboard';
import PayrollEmployees from './pages/finance-portal/payroll-employees/PayrollEmployees';
import PayrollEmployeeForm from './pages/finance-portal/payroll-employees/PayrollEmployeeForm';
import PayrollRuns from './pages/finance-portal/payroll-runs/PayrollRuns';
import PayrollRunDetail from './pages/finance-portal/payroll-runs/PayrollRunDetail';
import PayStubs from './pages/finance-portal/pay-stubs/PayStubs';
import PayStubDetail from './pages/finance-portal/pay-stubs/PayStubDetail';
import ContractorPayments from './pages/finance-portal/contractor-payments/ContractorPayments';
import BenefitPlans from './pages/finance-portal/benefit-plans/BenefitPlans';
import TaxDocuments from './pages/finance-portal/tax-documents/TaxDocuments';
import TaxDocumentDetail from './pages/finance-portal/tax-documents/TaxDocumentDetail';
import TaxFilings from './pages/finance-portal/tax-filings/TaxFilings';
import PayrollSettings from './pages/finance-portal/payroll-settings/PayrollSettings';
import NewHireReports from './pages/finance-portal/new-hire-reports/NewHireReports';
import ACACompliance from './pages/finance-portal/aca-compliance/ACACompliance';
import EarnedWageAccess from './pages/finance-portal/earned-wage-access/EarnedWageAccess';
import ComplianceFilings from './pages/finance-portal/compliance-filings/ComplianceFilings';
import StripePayments from './pages/finance-portal/stripe-payments/StripePayments';
import StripeTreasury from './pages/finance-portal/stripe-treasury/StripeTreasury';
import StripeIssuing from './pages/finance-portal/stripe-issuing/StripeIssuing';
import GeneralLedger from './pages/finance-portal/general-ledger/GeneralLedger';
import FinanceGuide from './pages/finance-portal/getting-started/FinanceGuide';
import IncomeStatement from './pages/finance-portal/reports/IncomeStatement';
import BalanceSheet from './pages/finance-portal/reports/BalanceSheet';
import CashFlowStatement from './pages/finance-portal/reports/CashFlowStatement';
import StatementOfEquity from './pages/finance-portal/reports/StatementOfEquity';
import TrialBalanceReport from './pages/finance-portal/reports/TrialBalance';
import GLDetailReport from './pages/finance-portal/reports/GLDetailReport';
import BudgetVsActual from './pages/finance-portal/reports/BudgetVsActual';
import DepartmentalPnL from './pages/finance-portal/reports/DepartmentalPnL';
import ProjectProfitability from './pages/finance-portal/reports/ProjectProfitability';
import CustomerProfitability from './pages/finance-portal/reports/CustomerProfitability';
import KpiDashboards from './pages/finance-portal/reports/KpiDashboards';
import BoardReports from './pages/finance-portal/reports/BoardReports';
import Forecasting from './pages/finance-portal/reports/Forecasting';
import FinancialRatios from './pages/finance-portal/reports/FinancialRatios';
import CohortAnalysis from './pages/finance-portal/reports/CohortAnalysis';
import BurnRunway from './pages/finance-portal/reports/BurnRunway';
import IndustryBenchmarks from './pages/finance-portal/reports/IndustryBenchmarks';
import CustomReportBuilder from './pages/finance-portal/reports/CustomReportBuilder';
import InvoiceDisputes from './pages/finance-portal/invoice-disputes/InvoiceDisputes';
import RecurringBills from './pages/finance-portal/recurring-bills/RecurringBills';
import Receipts from './pages/finance-portal/receipts/Receipts';
import PerDiem from './pages/finance-portal/per-diem/PerDiem';
import TaxExemptions from './pages/finance-portal/tax-exemptions/TaxExemptions';
import IncomeTax from './pages/finance-portal/income-tax/IncomeTax';
import EstimatedTax from './pages/finance-portal/estimated-tax/EstimatedTax';
import DepreciationAssets from './pages/finance-portal/depreciation/DepreciationAssets';
import TaxDocOrganizer from './pages/finance-portal/tax-doc-organizer/TaxDocOrganizer';
import TaxAuditTrail from './pages/finance-portal/tax-audit-trail/TaxAuditTrail';
import TaxReturnFilings from './pages/finance-portal/tax-return-filings/TaxReturnFilings';
import TaxPlanning from './pages/finance-portal/tax-planning/TaxPlanning';
import SalesTax from './pages/finance-portal/sales-tax/SalesTax';
import TaxNexus from './pages/finance-portal/tax-nexus/TaxNexus';
import TaxNotices from './pages/finance-portal/tax-notices/TaxNotices';
import TaxSettings from './pages/finance-portal/tax-settings/TaxSettings';
import ManageUsers from './pages/creator-panel/Users/ManageUsers';
import ManageRoles from './pages/creator-panel/Roles/ManageRoles';

import SalesforceConnector from './pages/creator-panel/Connector/Salesforce/SalesforceConnector';
import SuggestedQuestionsSettings from './pages/creator-panel/SuggestedQuestions/SuggestedQuestionsSettings.js';
import ProactiveMessagesSettings from './pages/creator-panel/ProactiveMessages/ProactiveMessagesSettings.js';
import TermsManagement from './pages/creator-panel/Terms/TermsManagement.js';

// Event Management and Outreach Campaigns
import VolunteerManagement from './pages/creator-panel/Campaigns/VolunteerManagement/VolunteerManagement.js';
import EventManagement from './pages/creator-panel/Campaigns/VolunteerManagement/EventManagement';
import OutreachCampaignWizard from './pages/creator-panel/Campaigns/VolunteerManagement/OutreachCampaignWizard';
import EventVolunteers from './pages/creator-panel/Campaigns/VolunteerManagement/EventVolunteers';
import PublicAvailabilityForm from './pages/creator-panel/Public/Volunteer/VolunteerAvailabilityForm';
import PublicVolunteerRegistrationForm from './pages/creator-panel/Public/Volunteer/PublicVolunteerRegistrationForm';
import OutreachDistribution from './pages/creator-panel/Campaigns/VolunteerManagement/OutreachDistribution';
import OutreachEmailWizard from './pages/creator-panel/Campaigns/VolunteerManagement/OutreachEmailWizard';
import OutreachSmsWizard from './pages/creator-panel/Campaigns/VolunteerManagement/OutreachSmsWizard';
import EventCalendarView from './pages/creator-panel/Campaigns/VolunteerManagement/EventCalendarView';
import PublicEventCalendar from './pages/creator-panel/Public/Volunteer/PublicEventCalendar';
import EventTraining from './pages/creator-panel/Campaigns/VolunteerManagement/EventTraining';

// Event Post Management
import EventPostManagement from './pages/creator-panel/Campaigns/EventPost/EventPostManagement';
import EventPostEditor from './pages/creator-panel/Campaigns/EventPost/EventPostEditor';
import EventPostCategories from './pages/creator-panel/Campaigns/EventPost/EventPostCategories';
import EventPostAPIHelp from './pages/creator-panel/Campaigns/EventPost/EventPostAPIHelp';
import PublicEventPostList from './pages/creator-panel/Public/EventPost/PublicEventPostList';
import PublicEventPostDetail from './pages/creator-panel/Public/EventPost/PublicEventPostDetail';

import ListConsentedContacts from './pages/creator-panel/ConsentedContacts/ListConsentedContacts'
import TwitterConnector from './pages/creator-panel/Connector/Twitter/TwitterConnector';
import ChatSpace from './pages/creator-panel/ChatSpace/ChatSpace';
import ChatSpaceDistribute from './pages/creator-panel/ChatSpace/ChatSpaceDistribute';
import PublicChatSpace from './pages/creator-panel/Public/ChatSpace/PublicChatSpace';

// LMS
import LMSDashboard from './pages/creator-panel/LMS/LMSDashboard';
import CourseBuilder from './pages/creator-panel/LMS/CourseBuilder';
import CourseEnrollments from './pages/creator-panel/LMS/Courses/CourseEnrollments';
import CoursePreview from './pages/creator-panel/LMS/Courses/CoursePreview';
import StudentList from './pages/creator-panel/LMS/Students/StudentList';
import StudentDetail from './pages/creator-panel/LMS/Students/StudentDetail';
import StudentEnrollments from './pages/creator-panel/LMS/Students/StudentEnrollments';
import StudentImport from './pages/creator-panel/LMS/Students/StudentImport';
import EnrollmentList from './pages/creator-panel/LMS/Enrollments/EnrollmentList';
import EnrollmentProgress from './pages/creator-panel/LMS/Enrollments/EnrollmentProgress';
import LMSAnalytics from './pages/creator-panel/LMS/Analytics/LMSAnalytics';
import CourseAnalytics from './pages/creator-panel/LMS/Analytics/CourseAnalytics';
import TestBuilder from './pages/creator-panel/LMS/Tests/TestBuilder';
import TestResults from './pages/creator-panel/LMS/Tests/TestResults';
import PointsConfig from './pages/creator-panel/LMS/Gamification/PointsConfig';
import BadgeManagement from './pages/creator-panel/LMS/Gamification/BadgeManagement';
import Leaderboard from './pages/creator-panel/LMS/Gamification/Leaderboard';
import CourseInvitations from './pages/creator-panel/LMS/Invitations/CourseInvitations';
import LMSEmbedPages from './pages/creator-panel/LMS/LMSEmbedPages';

// CRM Imports
import CRMLandingPage from './pages/creator-panel/CRM/CRMLandingPage';
import CRMDashboard from './pages/creator-panel/CRM/Core/CRMDashboard';
import ContactsList from './pages/creator-panel/CRM/Core/ContactsList';
import ContactDetail from './pages/creator-panel/CRM/Core/ContactDetail';
import AccountsList from './pages/creator-panel/CRM/Core/AccountsList';
import AccountDetail from './pages/creator-panel/CRM/Core/AccountDetail';
import LeadsList from './pages/creator-panel/CRM/Core/LeadsList';
import LeadDetail from './pages/creator-panel/CRM/Core/LeadDetail';
import PublicLeadForm from './pages/creator-panel/Public/CRM/PublicLeadForm';
import TagsList from './pages/creator-panel/CRM/Core/TagsList';
import ServiceRemindersPage from './pages/creator-panel/CRM/Core/ServiceRemindersPage';

// CRM SFA Imports
import SFADashboard from './pages/creator-panel/CRM/SFA/SFADashboard';
import OpportunityList from './pages/creator-panel/CRM/SFA/OpportunityList';
import OpportunityDetail from './pages/creator-panel/CRM/SFA/OpportunityDetail';
import OpportunityForm from './pages/creator-panel/CRM/SFA/OpportunityForm';
import OpportunityPipeline from './pages/creator-panel/CRM/SFA/OpportunityPipeline';
import ForecastDashboard from './pages/creator-panel/CRM/SFA/ForecastDashboard';
import ProductList from './pages/creator-panel/CRM/SFA/ProductList';
import CategoryManagement from './pages/creator-panel/CRM/SFA/CategoryManagement';
import PriceBookList from './pages/creator-panel/CRM/SFA/PriceBookList';
import QuoteList from './pages/creator-panel/CRM/SFA/QuoteList';
import QuoteBuilder from './pages/creator-panel/CRM/SFA/QuoteBuilder';
import QuoteDetail from './pages/creator-panel/CRM/SFA/QuoteDetail';
import SalesTargets from './pages/creator-panel/CRM/SFA/SalesTargets';
import SalesTeams from './pages/creator-panel/CRM/SFA/SalesTeams';
import TerritoryManagement from './pages/creator-panel/CRM/SFA/TerritoryManagement';
import LostReasonAnalytics from './pages/creator-panel/CRM/SFA/LostReasonAnalytics';
import LMSEmbedViewer from './pages/creator-panel/LMS/LMSEmbedViewer.js';

// CRM Finance Imports
import SalesTransactionDashboard from './pages/creator-panel/CRM/SalesTransaction/SalesTransactionDashboard';
import InvoiceList from './pages/creator-panel/CRM/SalesTransaction/InvoiceList';
import InvoiceForm from './pages/creator-panel/CRM/SalesTransaction/InvoiceForm';
import InvoiceDetail from './pages/creator-panel/CRM/SalesTransaction/InvoiceDetail';
import PaymentList from './pages/creator-panel/CRM/SalesTransaction/PaymentList';

// CRM Help Desk Imports
import HelpDeskDashboard from './pages/creator-panel/CRM/HelpDesk/HelpDeskDashboard';
import TicketList from './pages/creator-panel/CRM/HelpDesk/TicketList';
import TicketDetail from './pages/creator-panel/CRM/HelpDesk/TicketDetail';
import TicketCategoryList from './pages/creator-panel/CRM/HelpDesk/TicketCategoryList';
import SLAPolicyList from './pages/creator-panel/CRM/HelpDesk/SLAPolicyList';
import KnowledgeBase from './pages/creator-panel/CRM/HelpDesk/KnowledgeBase';

// CRM Activity & Communication Imports
import ActivityCommDashboard from './pages/creator-panel/CRM/ActivityComm/ActivityCommDashboard';
import TaskList from './pages/creator-panel/CRM/ActivityComm/TaskList';
import TaskDetail from './pages/creator-panel/CRM/ActivityComm/TaskDetail';
import MyTasks from './pages/creator-panel/CRM/ActivityComm/MyTasks';
import CalendarView from './pages/creator-panel/CRM/ActivityComm/CalendarView';
import CalendarConnections from './pages/creator-panel/CRM/ActivityComm/CalendarConnections';
import BookingPageList from './pages/creator-panel/CRM/ActivityComm/BookingPageList';
import BookingPageForm from './pages/creator-panel/CRM/ActivityComm/BookingPageForm';
import EmailSyncSettings from './pages/creator-panel/CRM/ActivityComm/EmailSyncSettings';
import CommunicationLog from './pages/creator-panel/CRM/ActivityComm/CommunicationLog';
import PublicBookingPage from './pages/creator-panel/CRM/ActivityComm/PublicBookingPage';
import WorkflowList from './pages/creator-panel/CRM/ActivityComm/WorkflowList';
import WorkflowForm from './pages/creator-panel/CRM/ActivityComm/WorkflowForm';
import WorkflowDetail from './pages/creator-panel/CRM/ActivityComm/WorkflowDetail';

// HRM Imports
import HRMLandingPage from './pages/creator-panel/HRM/HRMLandingPage';
import HRMDashboard from './pages/creator-panel/HRM/Core/HRMDashboard';
import EmployeeList from './pages/creator-panel/HRM/Core/EmployeeList';
import EmployeeDetail from './pages/creator-panel/HRM/Core/EmployeeDetail';
import DepartmentList from './pages/creator-panel/HRM/Core/DepartmentList';
import PositionList from './pages/creator-panel/HRM/Core/PositionList';
import EmployeeLifecycle from './pages/creator-panel/HRM/Core/EmployeeLifecycle';

// HRM Recruitment Imports
import RecruitmentDashboard from './pages/creator-panel/HRM/Recruitment/RecruitmentDashboard';
import JobList from './pages/creator-panel/HRM/Recruitment/JobList';
import JobDetail from './pages/creator-panel/HRM/Recruitment/JobDetail';
import ApplicantList from './pages/creator-panel/HRM/Recruitment/ApplicantList';
import ApplicantDetail from './pages/creator-panel/HRM/Recruitment/ApplicantDetail';
import InterviewList from './pages/creator-panel/HRM/Recruitment/InterviewList';
import OfferList from './pages/creator-panel/HRM/Recruitment/OfferList';

function App() {
    const isLoggedIn = localStorage.getItem('user');
    const [isCollapsed, setIsCollapsed] = useState(false);

    const handleToggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };

    // --- Role-based default redirect ---
    const DefaultRedirect = () => {
        const userStr = localStorage.getItem('user');
        const user = userStr ? JSON.parse(userStr) : null;
        const role = user?.active_team?.user_role_in_team?.toLowerCase();

        if (role === 'student') return <Navigate to="/student-portal/dashboard" replace />;
        if (role === 'customer') return <Navigate to="/customer-panel/dashboard" replace />;
        return <Navigate to="/chatbots" replace />;
    };

    // --- Route Protector ---
    const ProtectedRoute = ({ children }) => {
        const { activeChatbot } = useChatbots();
        if (!activeChatbot || !activeChatbot.is_process_completed) {
            const redirectPath = activeChatbot
                ? `/chatbot/create`
                : '/chatbots';
            return <Navigate to={redirectPath} replace />;
        }
        return children;
    };


    return (
        <Routes>
            {/* Routes outside Layout (Publicly Accessible) */}
            <Route path="/SignUp-Process-Steps" element={<SignUpSteps />} />
            <Route path="/Login" element={<SignIn />} />
            <Route path="/resubscribe" element={<Resubscribe />} />
            <Route path="/linkedin-callback" element={<LinkedInCallback />} />
            <Route path="/SignUp" element={<SignUp />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/log-out" element={<LogoutPage />} />
            <Route path="/live" element={<LiveChatbot />} />
            <Route path="/verify/:token" element={<VerifiedEmail />} />
            <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
            <Route path="/registration" element={<StudentRegistration />} />
            <Route path="/invitation-external/:token" element={<CustomerInvitationPage />} />
            <Route path="/pay/:payToken" element={<PublicPaymentPage />} />
            <Route path="/finance/portal/:portalToken" element={<FinanceCustomerPortal />} />
            <Route path="/finance/pay/:token" element={<FinancePublicPayment />} />
            <Route path="/pay/payment-success" element={<PaymentSuccessPage />} />
            <Route path="/pay/payment-cancel" element={<PaymentCancelPage />} />
            <Route path="/volunteer/availability/:token" element={<PublicAvailabilityForm />} />
            <Route path="/volunteer/register/:chatbotId" element={<PublicVolunteerRegistrationForm />} />
            <Route path="/events/calendar/:chatbotId" element={<PublicEventCalendar />} />
            <Route path="/posts/:chatbotId" element={<PublicEventPostList />} />
            <Route path="/posts/:chatbotId/:slug" element={<PublicEventPostDetail />} />
            <Route path="/lead-form/:formUuid" element={<PublicLeadForm />} />

            {/* Public Guest Signature */}
            <Route path="/guest-sign/:token" element={<GuestSignPage />} />

            {/* Public Survey Form */}
            <Route path="/s/:surveyUuid" element={<PublicSurveyForm />} />

            {/* Public Chat Space (Embeddable) */}
            <Route path="/cs/:chatbotIdentity" element={<PublicChatSpace />} />

            {/* Public Booking Page */}
            <Route path="/book/:bookingUuid" element={<PublicBookingPage />} />

            <Route path="/lms/course/embbed/:token" element={<LMSEmbedViewer />} />
            {/* --- Authenticated Routes --- */}
            {isLoggedIn ? (
                <Route path="/" element={<Layout isCollapsed={isCollapsed} onToggleSidebar={handleToggleSidebar} />}>
                    
                    {/* 1. STANDALONE ROUTES: Wrapped by Layout, but NOT ChatbotLayout */}
                    <Route index element={<DefaultRedirect />} />
                    <Route path="chatbots" element={<MyChatbots />} />
                    <Route path="chatbot/create" element={<ChatbotCreationSteps />} />
                    <Route path="user-profile" element={<UserProfile />} />
                    <Route path="exception-log" element={<ListExceptionLog />} />
                    {/* <Route path="Link-accounts" element={<LinkedAccounts />} /> */}
                    <Route path="Test" element={<Test />} />
                    <Route path="help" element={<Help />} />
                    <Route path="support" element={<Support />} />
                    <Route path="privacy" element={<Privacy />} />
                    <Route path="terms" element={<Terms />} />
                    <Route path="Billing" element={<Billing />} />
                    <Route path="Billing/Billing-History" element={<InvoiceHistory />} />
                    <Route path="Billing/Pricing" element={<Pricing />} />
                    <Route path="Billing/Subscription" element={<SubscriptionHistory />} />
                    <Route path="payment-success" element={<PaymentSuccess />} />

                    {/* ==================== CREATOR PANEL ROUTES ==================== */}
                    <Route path="creator-panel">
                        <Route path="notifications" element={<CreatorNotificationsPage />} />
                        <Route path="reminders" element={<CreatorRemindersPage />} />
                    </Route>

                    {/* ==================== CUSTOMER PANEL ROUTES ==================== */}
                    <Route path="customer-panel">
                        <Route path="dashboard" element={<CustomerDashboard />} />

                        {/* Live Conversations */}
                        <Route path="live-agents/live-conversations" element={<LiveConversationsPage />} />
                        <Route path="live-agents/conversations-history" element={<LiveChatHistoryPage />} />
                        <Route path="live-agents/analytics" element={<AgentSpacePage />} />
                        <Route path="live-agents/sudo-profile" element={<SudoProfilePage />} />

                        {/* Chat */}
                        <Route path="chat" element={<ChatPage />} />
                        <Route path="chat-history" element={<ChatHistoryPage />} />

                        {/* Documents & Signatures */}
                        <Route path="documents" element={<DocumentsPage />} />
                        <Route path="documents/:userId" element={<UserDocumentsPage />} />
                        <Route path="signatures" element={<SignaturesPage />} />
                        <Route path="signatures/:token" element={<SignDocumentPage />} />

                        {/* LMS - Courses */}
                        <Route path="courses" element={<CoursesPage />} />
                        <Route path="courses/:courseIdentity" element={<CourseDetailPage />} />
                        <Route path="my-courses" element={<MyCoursesPage />} />

                        {/* LMS - Certificates & Achievements */}
                        <Route path="certificates" element={<CertificatesPage />} />
                        <Route path="certificates/:id" element={<CertificateDetailPage />} />
                        <Route path="achievements" element={<AchievementsPage />} />
                        <Route path="leaderboard" element={<LeaderboardPage />} />
                        <Route path="enrollments" element={<EnrollmentsPage />} />

                        {/* Core Pages */}
                        <Route path="profile" element={<ProfilePage />} />
                        <Route path="users" element={<UsersPage />} />
                        <Route path="requests" element={<RequestsPage />} />
                        <Route path="invoices" element={<InvoicesPage />} />
                        <Route path="invoices/:id" element={<InvoiceDetailPage />} />
                        <Route path="feedback" element={<FeedbackPage />} />
                        <Route path="notifications" element={<NotificationsPage />} />
                        <Route path="reminders" element={<RemindersPage />} />
                        <Route path="calendar" element={<CalendarPage />} />
                        <Route path="payment-methods" element={<PaymentMethodsPage />} />
                        <Route path="subscription" element={<SubscriptionPlanPage />} />

                        {/* Appointments */}
                        <Route path="appointments" element={<AppointmentsPage />} />
                        <Route path="appointment-settings" element={<AppointmentSettingsPage />} />

                        {/* Support Tickets */}
                        <Route path="support" element={<SupportTicketsPage />} />
                        <Route path="support/new" element={<CreateTicketPage />} />
                        <Route path="support/:ticketId" element={<TicketDetailPage />} />

                        <Route path="settings" element={<CustomerSettingsPage />} />
                        <Route path="drive-settings" element={<DriveSettingsPage />} />

                        {/* Personalize */}
                        <Route path="personalize/documents" element={<PersonalizeDocumentsPage />} />
                        <Route path="personalize/emails" element={<PersonalizeEmailsPage />} />
                        <Route path="personalize/voice" element={<PersonalizeVoicePage />} />
                        <Route path="personalize/website" element={<PersonalizeWebsitePage />} />
                    </Route>

                    {/* ==================== STUDENT PORTAL ROUTES ==================== */}
                    <Route path="student-portal">
                        <Route path="dashboard" element={<StudentDashboard />} />
                        <Route path="notifications" element={<StudentNotificationsPage />} />
                        <Route path="reminders" element={<StudentRemindersPage />} />
                        <Route path="courses" element={<StCoursesPage />} />
                        <Route path="courses/:courseIdentity" element={<StCourseDetailPage />} />
                        <Route path="my-courses" element={<StMyCoursesPage />} />
                        <Route path="certificates" element={<StCertificatesPage />} />
                        <Route path="certificates/:id" element={<StCertificateDetailPage />} />
                        <Route path="achievements" element={<StAchievementsPage />} />
                        <Route path="leaderboard" element={<StLeaderboardPage />} />
                        <Route path="enrollments" element={<StEnrollmentsPage />} />
                        <Route path="payment-methods" element={<StPaymentMethodsPage />} />
                    </Route>

                    {/* ==================== TRADING PORTAL ROUTES ==================== */}
                    <Route path="trading-portal">
                        <Route path="dashboard" element={<TradingDashboard />} />
                        <Route path="watchlist" element={<WatchlistPage />} />
                        <Route path="symbol-detail/:symbolId" element={<SymbolDetailPage />} />
                        <Route path="market-data" element={<MarketDataPage />} />
                        <Route path="historical" element={<HistoricalDataPage />} />
                        <Route path="indicators" element={<IndicatorsPage />} />
                        <Route path="alerts" element={<AlertsPage />} />
                        <Route path="market-data-ingestion" element={<MarketDataIngestionDashboard />} />
                        <Route path="market-data-ingestion/price-feed" element={<StockPriceFeedPage />} />
                        <Route path="market-data-ingestion/options-chain" element={<OptionsChainPage />} />
                        <Route path="market-data-ingestion/options-chain/payoff/:contractId" element={<OptionsPayoffPage />} />
                        <Route path="market-data-ingestion/options-chain/single-option-payoff/:symbolId" element={<SingleOptionPayoffPage />} />
                        <Route path="market-data-ingestion/macro-economic" element={<MacroEconomicPage />} />
                        <Route path="market-data-ingestion/btc-correlation" element={<BitcoinCorrelationPage />} />
                        <Route path="market-data-ingestion/liquidity-engine" element={<FedLiquidityEnginePage />} />
                        <Route path="market-data-ingestion/data-quality" element={<DataQualityPage />} />
                        <Route path="options-contract-management" element={<OptionsContractManagementDashboard />} />
                        <Route path="options-contract-management/contract-discovery" element={<ContractDiscoveryPage />} />
                        <Route path="options-contract-management/positions" element={<PositionManagementPage />} />
                        <Route path="options-contract-management/expiration-settlement" element={<ExpirationSettlementPage />} />
                        <Route path="options-contract-management/strategy-analyzer" element={<StrategyAnalyzerPage />} />
                        {/* AI Analysis Engine */}
                        <Route path="ai-analysis-engine" element={<AIAnalysisEngineDashboard />} />
                        <Route path="ai-analysis-engine/volatility-prediction" element={<VolatilityPredictionPage />} />
                        <Route path="ai-analysis-engine/market-regime-detection" element={<MarketRegimeDetectionPage />} />
                        <Route path="ai-analysis-engine/signal-generation" element={<SignalGenerationPage />} />
                        <Route path="ai-analysis-engine/sentiment-data" element={<SentimentAlternativeDataPage />} />
                        {/* Trade Execution Engine */}
                        <Route path="trade-execution" element={<TradeExecutionDashboard />} />
                        <Route path="trade-execution/orders" element={<OrderManagementPage />} />
                        <Route path="trade-execution/algorithms" element={<ExecutionAlgorithmsPage />} />
                        <Route path="trade-execution/risk-controls" element={<RiskControlsPage />} />
                        <Route path="trade-execution/post-trade" element={<PostTradeProcessingPage />} />
                        <Route path="trade-execution/trading-bots" element={<TradingBotPage />} />
                        {/* Volatility Arbitrage Engine */}
                        <Route path="volatility-arbitrage" element={<VolatilityArbitrageDashboard />} />
                        <Route path="volatility-arbitrage/opportunity-detection" element={<OpportunityDetectionPage />} />
                        <Route path="volatility-arbitrage/strategy-construction" element={<StrategyConstructionPage />} />
                        <Route path="volatility-arbitrage/delta-hedging" element={<DeltaHedgingPage />} />
                        <Route path="volatility-arbitrage/pnl-attribution" element={<PnlAttributionPage />} />
                    </Route>

                    {/* ==================== FINANCE PORTAL ROUTES ====================
                        Wrapped in FinanceCRMGate so any user without at least one
                        CRM client is bounced to /crm/clients to create one first
                        (every finance row is scoped by crm_account_id). */}
                    <Route path="finance-portal" element={<FinanceCRMGate />}>
                        <Route path="dashboard" element={<FinanceDashboard />} />
                        <Route path="agent-console" element={<AgentConsole />} />
                        <Route path="posting-monitor" element={<PostingMonitor />} />
                        <Route path="banking" element={<BankingCenter />} />
                        <Route path="connected-accounts" element={<ConnectedAccounts />} />

                        {/* Cash Position Management */}
                        <Route path="cash-position" element={<CashPositionDashboard />} />
                        <Route path="cash-flow-calendar" element={<CashFlowCalendar />} />
                        <Route path="cash-alerts" element={<MinimumBalanceAlerts />} />
                        <Route path="treasury-sweeps" element={<TreasurySweepRules />} />
                        <Route path="cash-concentration" element={<CashConcentrationReport />} />
                        <Route path="float-management" element={<FloatManagement />} />
                        {/* Bank Reconciliation */}
                        <Route path="bank-reconciliation" element={<ReconciliationHub />} />
                        <Route path="bank-reconciliation/archive" element={<ReconciliationArchive />} />
                        <Route path="bank-reconciliation/:reconciliationId" element={<ReconciliationWorksheet />} />

                        {/* Inventory & Product Management Engine */}
                        <Route path="inventory/dashboard" element={<InventoryDashboard />} />
                        <Route path="inventory/products" element={<Products />} />
                        <Route path="inventory/products/new" element={<ProductForm />} />
                        <Route path="inventory/products/:productId" element={<ProductDetail />} />
                        <Route path="inventory/products/:productId/edit" element={<ProductForm />} />
                        <Route path="inventory/locations" element={<Locations />} />
                        <Route path="inventory/levels" element={<InventoryLevels />} />
                        <Route path="inventory/purchase-orders" element={<PurchaseOrders />} />
                        <Route path="inventory/purchase-orders/new" element={<POForm />} />
                        <Route path="inventory/purchase-orders/:poId" element={<PODetail />} />
                        <Route path="inventory/purchase-orders/:poId/edit" element={<POForm />} />
                        <Route path="inventory/receiving" element={<Receiving />} />
                        <Route path="inventory/receiving/new" element={<ReceiveForm />} />
                        <Route path="inventory/receiving/:receiptId" element={<ReceiveForm />} />
                        <Route path="inventory/adjustments" element={<InventoryAdjustments />} />
                        <Route path="inventory/reorder" element={<ReorderPlanner />} />
                        <Route path="inventory/counts" element={<InventoryCounts />} />
                        <Route path="inventory/landed-costs" element={<LandedCosts />} />
                        <Route path="inventory/lots-serials" element={<LotsSerials />} />

                        {/* Fixed Asset Management Engine */}
                        <Route path="fixed-assets" element={<FixedAssetsDashboard />} />
                        <Route path="fixed-assets/dashboard" element={<FixedAssetsDashboard />} />
                        <Route path="fixed-assets/assets" element={<FAAssets />} />
                        <Route path="fixed-assets/assets/new" element={<FAAssetForm />} />
                        <Route path="fixed-assets/assets/:assetId" element={<FAAssetDetail />} />
                        <Route path="fixed-assets/assets/:assetId/edit" element={<FAAssetForm />} />
                        <Route path="fixed-assets/categories" element={<FACategories />} />
                        <Route path="fixed-assets/depreciation" element={<FADepreciation />} />
                        <Route path="fixed-assets/cip" element={<FACIPProjects />} />
                        <Route path="fixed-assets/disposals" element={<FADisposals />} />
                        <Route path="fixed-assets/operations" element={<FAOperations />} />
                        <Route path="fixed-assets/reports" element={<FAReports />} />
                        <Route path="fixed-assets/agent" element={<FAAgent />} />

                        <Route path="chart-of-accounts" element={<ChartOfAccounts />} />
                        <Route path="journal-entries" element={<JournalEntries />} />
                        <Route path="trial-balance" element={<TrialBalance />} />
                        <Route path="customers" element={<Customers />} />
                        <Route path="customers/:customerId" element={<CustomerDetail />} />
                        <Route path="invoices" element={<Invoices />} />
                        <Route path="invoices/new" element={<FinanceInvoiceForm />} />
                        <Route path="invoices/:invoiceId" element={<FinanceInvoiceDetail />} />
                        <Route path="invoices/:invoiceId/edit" element={<FinanceInvoiceForm />} />
                        <Route path="payments" element={<FinancePayments />} />
                        <Route path="invoice-templates" element={<InvoiceTemplates />} />
                        <Route path="estimates" element={<Estimates />} />
                        <Route path="estimates/new" element={<EstimateForm />} />
                        <Route path="estimates/:estimateId" element={<EstimateDetail />} />
                        <Route path="estimates/:estimateId/edit" element={<EstimateForm />} />
                        <Route path="credit-memos" element={<CreditMemos />} />
                        <Route path="credit-memos/new" element={<CreditMemoForm />} />
                        <Route path="credit-memos/:memoId" element={<CreditMemoDetail />} />
                        <Route path="ar-aging" element={<ARAgingReport />} />
                        <Route path="ar-settings" element={<ARSettings />} />
                        <Route path="payment-links" element={<PaymentLinks />} />
                        <Route path="cash-application" element={<CashApplication />} />
                        <Route path="statements" element={<Statements />} />
                        <Route path="statements/:statementId" element={<StatementDetail />} />
                        <Route path="recurring-invoices" element={<RecurringInvoices />} />
                        <Route path="recurring-invoices/new" element={<RecurringInvoiceForm />} />
                        <Route path="recurring-invoices/:recurringId/edit" element={<RecurringInvoiceForm />} />
                        <Route path="revenue-recognition" element={<RevenueRecognition />} />
                        <Route path="transactions" element={<Transactions />} />
                        <Route path="recurring-transactions" element={<RecurringTransactions />} />
                        <Route path="balance-history" element={<BalanceHistory />} />
                        <Route path="category-mapping" element={<CategoryMapping />} />
                        <Route path="dimensions" element={<Dimensions />} />
                        <Route path="journal-mappings" element={<JournalMappings />} />
                        <Route path="recurring-journals" element={<RecurringJournals />} />
                        <Route path="journal-approvals" element={<JournalApprovals />} />
                        <Route path="period-closing" element={<PeriodClosing />} />
                        {/* Accounts Payable */}
                        <Route path="vendors" element={<Vendors />} />

                        {/* Budgeting & FP&A */}
                        <Route path="executive-dashboard" element={<ExecutiveDashboard />} />
                        <Route path="budgets" element={<Budgets />} />
                        <Route path="budgets/:budgetId" element={<BudgetDetail />} />
                        <Route path="budgets/:budgetId/variance" element={<BudgetVariance />} />

                        {/* Procurement & Supply Chain */}
                        <Route path="requisitions" element={<Requisitions />} />
                        <Route path="requisitions/new" element={<RequisitionForm />} />
                        <Route path="requisitions/:requisitionId" element={<RequisitionDetail />} />
                        <Route path="requisitions/:requisitionId/edit" element={<RequisitionForm />} />
                        <Route path="procurement-pos" element={<ProcurementPOs />} />
                        <Route path="procurement-pos/new" element={<ProcurementPOForm />} />
                        <Route path="procurement-pos/:poId" element={<ProcurementPODetail />} />
                        <Route path="procurement-pos/:poId/edit" element={<ProcurementPOForm />} />

                        {/* Loan & Debt Management */}
                        <Route path="loans" element={<Loans />} />
                        <Route path="loans/new" element={<LoanForm />} />
                        <Route path="loans/:loanId" element={<LoanDetail />} />
                        <Route path="loans/:loanId/edit" element={<LoanForm />} />

                        {/* Lease Accounting (ASC 842) */}
                        <Route path="leases" element={<Leases />} />
                        <Route path="leases/new" element={<LeaseForm />} />
                        <Route path="leases/:leaseId" element={<LeaseDetail />} />
                        <Route path="leases/:leaseId/edit" element={<LeaseForm />} />

                        {/* Intercompany & Transfer Pricing */}
                        <Route path="ic-netting" element={<IcNetting />} />
                        <Route path="ic-netting/:runId" element={<IcNettingDetail />} />
                        <Route path="ic-reconciliation" element={<IcReconciliation />} />
                        <Route path="tp-policies" element={<TpPolicies />} />
                        <Route path="tp-policies/new" element={<TpPolicyForm />} />
                        <Route path="tp-policies/:policyId" element={<TpPolicyForm />} />
                        <Route path="tp-adjustments" element={<TpAdjustments />} />
                        <Route path="tp-adjustments/new" element={<TpAdjustmentForm />} />
                        <Route path="tp-adjustments/:adjId" element={<TpAdjustmentForm />} />

                        <Route path="bills" element={<Bills />} />
                        <Route path="bills/new" element={<BillForm />} />
                        <Route path="bills/:billId/edit" element={<BillForm />} />
                        <Route path="bill-payments" element={<BillPayments />} />
                        <Route path="ap-aging" element={<APAgingReport />} />
                        {/* Expense Management */}
                        <Route path="expenses" element={<Expenses />} />
                        <Route path="expense-reports" element={<ExpenseReports />} />
                        <Route path="expense-reports/:reportId" element={<ExpenseReportDetail />} />
                        <Route path="expense-categories" element={<ExpenseCategories />} />

                        {/* Payroll  */}
                        <Route path="payroll-dashboard" element={<PayrollDashboard />} />
                        <Route path="payroll-employees" element={<PayrollEmployees />} />
                        <Route path="payroll-employees/new" element={<PayrollEmployeeForm />} />
                        <Route path="payroll-employees/:employeeId/edit" element={<PayrollEmployeeForm />} />
                        <Route path="payroll-runs" element={<PayrollRuns />} />
                        <Route path="payroll-runs/:runId" element={<PayrollRunDetail />} />
                        <Route path="pay-stubs" element={<PayStubs />} />
                        <Route path="pay-stubs/:stubId" element={<PayStubDetail />} />
                        <Route path="contractor-payments" element={<ContractorPayments />} />
                        <Route path="benefit-plans" element={<BenefitPlans />} />
                        <Route path="tax-documents" element={<TaxDocuments />} />
                        <Route path="tax-documents/:documentId" element={<TaxDocumentDetail />} />
                        <Route path="tax-filings" element={<TaxFilings />} />
                        <Route path="payroll-settings" element={<PayrollSettings />} />
                        <Route path="new-hire-reports" element={<NewHireReports />} />
                        <Route path="aca-compliance" element={<ACACompliance />} />
                        <Route path="earned-wage-access" element={<EarnedWageAccess />} />
                        <Route path="compliance-filings" element={<ComplianceFilings />} />
                        <Route path="stripe-payments" element={<StripePayments />} />
                        <Route path="stripe-treasury" element={<StripeTreasury />} />
                        <Route path="stripe-issuing" element={<StripeIssuing />} />
                        <Route path="general-ledger" element={<GeneralLedger />} />
                        <Route path="getting-started" element={<FinanceGuide />} />

                        {/* : Financial Reporting & BI */}
                        <Route path="reports/income-statement" element={<IncomeStatement />} />
                        <Route path="reports/balance-sheet" element={<BalanceSheet />} />
                        <Route path="reports/cash-flow" element={<CashFlowStatement />} />
                        <Route path="reports/statement-of-equity" element={<StatementOfEquity />} />
                        <Route path="reports/trial-balance" element={<TrialBalanceReport />} />
                        <Route path="reports/gl-detail" element={<GLDetailReport />} />
                        <Route path="reports/budget-vs-actual" element={<BudgetVsActual />} />
                        <Route path="reports/departmental-pnl" element={<DepartmentalPnL />} />
                        <Route path="reports/project-profitability" element={<ProjectProfitability />} />
                        <Route path="reports/customer-profitability" element={<CustomerProfitability />} />
                        <Route path="reports/kpi-dashboards" element={<KpiDashboards />} />
                        <Route path="reports/board-reports" element={<BoardReports />} />
                        <Route path="reports/forecasting" element={<Forecasting />} />
                        <Route path="reports/financial-ratios" element={<FinancialRatios />} />
                        <Route path="reports/cohort-analysis" element={<CohortAnalysis />} />
                        <Route path="reports/burn-runway" element={<BurnRunway />} />
                        <Route path="reports/industry-benchmarks" element={<IndustryBenchmarks />} />
                        <Route path="reports/custom-report-builder" element={<CustomReportBuilder />} />

                        <Route path="invoice-disputes" element={<InvoiceDisputes />} />
                        <Route path="recurring-bills" element={<RecurringBills />} />
                        <Route path="receipts" element={<Receipts />} />
                        <Route path="per-diem" element={<PerDiem />} />
                        <Route path="tax-exemptions" element={<TaxExemptions />} />
                        <Route path="income-tax" element={<IncomeTax />} />
                        <Route path="estimated-tax" element={<EstimatedTax />} />
                        <Route path="depreciation" element={<DepreciationAssets />} />
                        <Route path="tax-doc-organizer" element={<TaxDocOrganizer />} />
                        <Route path="tax-audit-trail" element={<TaxAuditTrail />} />
                        <Route path="tax-return-filings" element={<TaxReturnFilings />} />
                        <Route path="tax-planning" element={<TaxPlanning />} />
                        <Route path="sales-tax" element={<SalesTax />} />
                        <Route path="tax-nexus" element={<TaxNexus />} />
                        <Route path="tax-notices" element={<TaxNotices />} />
                        <Route path="tax-settings" element={<TaxSettings />} />

                        {/* Agent Hub (unified launcher for M8-15) */}
                        <Route path="agents" element={<AgentHub />} />
                        <Route path="agents/hub" element={<AgentHub />} />

                        {/* Agentic Transaction Intelligence */}
                        <Route path="agents/categorization" element={<CategorizationAgent />} />
                        <Route path="agents/reconciliation" element={<ReconciliationAgent />} />
                        <Route path="agents/merchant-rpa" element={<MerchantRPAAgent />} />
                        <Route path="agents/anomaly-detection" element={<AnomalyDetectionAgent />} />
                        <Route path="agents/data-quality" element={<DataQualityAgent />} />

                        {/* Agentic Financial Operations */}
                        <Route path="agents/cashflow-forecasting" element={<CashFlowForecastingAgent />} />
                        <Route path="agents/budget-variance" element={<BudgetVarianceAgent />} />
                        <Route path="agents/vendor-spend" element={<VendorSpendAgent />} />
                        <Route path="agents/working-capital" element={<WorkingCapitalAgent />} />

                        {/* Agentic Autonomous Workflow */}
                        <Route path="agents/month-end-close" element={<MonthEndCloseAgent />} />
                        <Route path="agents/ap-automation" element={<APAutomationAgent />} />
                        <Route path="agents/ar-automation" element={<ARAutomationAgent />} />
                        <Route path="agents/payroll-automation" element={<PayrollAutomationAgent />} />

                        {/* Natural Language Command Center */}
                        <Route path="agents/command-center" element={<FinanceCommandCenter />} />

                        {/* Document Intelligence Pipeline */}
                        <Route path="agents/document-intelligence" element={<DocumentIntelligenceAgent />} />

                        {/* Compliance, Fraud & Risk */}
                        <Route path="agents/fraud-detection" element={<FraudDetectionAgent />} />

                        {/* Learning & Continuous Improvement */}
                        <Route path="agents/feedback-learning" element={<FeedbackLearningAgent />} />
                        <Route path="agents/agent-performance" element={<AgentPerformanceAgent />} />
                        <Route path="agents/continuous-improvement" element={<ContinuousImprovementAgent />} />

                        {/* Multi-Entity & Multi-Currency */}
                        <Route path="entities" element={<Entities />} />
                        <Route path="intercompany" element={<Intercompany />} />
                        <Route path="consolidation" element={<Consolidation />} />
                        <Route path="exchange-rates" element={<ExchangeRates />} />
                        <Route path="fx-revaluation" element={<FXRevaluation />} />
                        <Route path="shared-services" element={<SharedServices />} />
                    </Route>

                    {/* --- User --- */}
                    <Route path="user-management/users" element={<ManageUsers />} />
                    <Route path="user-management/roles" element={<ManageRoles />} />

                    {/* --- Company Settings (non-chatbot-specific) --- */}
                    <Route path="settings/company-settings" element={<ProtectedRoute><CompanySettingsPage /></ProtectedRoute>} />
                    
                    {/* 2. NESTED ROUTES: Wrapped by Layout AND ChatbotLayout */}
                    <Route path="/chatbot/:chatbotId/*" element={<ChatbotLayout />}>
                        <Route index element={<Navigate to="dashboard" replace />} />
                        <Route path="wordpress-plugin" element={<WordpressPlugin />} />
                        <Route path="dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                            
                        <Route path="exception-log" element={<ListExceptionLog />} />
                        <Route path="wordpress-plugin" element={<WordpressPlugin />} />

                        {/* --- Configuration --- */}
                        <Route path="configuration" element={<ProtectedRoute><WebsiteConfigurations /></ProtectedRoute>} />
                        <Route path="sitemap" element={<ProtectedRoute><AddSitemap /></ProtectedRoute>} />
                        <Route path="avatar" element={<ProtectedRoute><AvatarSettings /></ProtectedRoute>} />
                        <Route path="audio-language" element={<ProtectedRoute><ListAudioLanguage /></ProtectedRoute>} />
                        <Route path="chatbot-settings" element={<ProtectedRoute><ChatbotSettings /></ProtectedRoute>} />
                        <Route path="live-conversation" element={<ProtectedRoute><LiveConversation /></ProtectedRoute>} />
                        <Route path="live-conversation/tools" element={<ProtectedRoute><ToolsList /></ProtectedRoute>} />
                        <Route path="live-conversation/tools/new" element={<ProtectedRoute><ToolForm /></ProtectedRoute>} />
                        <Route path="live-conversation/tools/:toolId/edit" element={<ProtectedRoute><ToolForm /></ProtectedRoute>} />
                        <Route path="live-phone-call" element={<ProtectedRoute><LivePhoneCall /></ProtectedRoute>} />
                        <Route path="live-phone-call/recordings" element={<ProtectedRoute><CallRecordings /></ProtectedRoute>} />
                        <Route path="call-logs" element={<ProtectedRoute><CallLogsListPage /></ProtectedRoute>} />
                        <Route path="phone-providers" element={<ProtectedRoute><PhoneProviderConfig /></ProtectedRoute>} />
                        <Route path="choose-position" element={<ProtectedRoute><ChoosePosition /></ProtectedRoute>} />
                        <Route path="thumbnail-color" element={<ProtectedRoute><ColorSettings /></ProtectedRoute>} />
                        <Route path="suggested-questions" element={<ProtectedRoute><SuggestedQuestionsSettings /></ProtectedRoute>} />
                        <Route path="proactive-messages" element={<ProtectedRoute><ProactiveMessagesSettings /></ProtectedRoute>} />
                        
                        {/* --- Data Sources --- */}
                        <Route path="website" element={<ProtectedRoute><Scraper /></ProtectedRoute>} />
                        <Route path="documents" element={<ProtectedRoute><AddDocuments /></ProtectedRoute>} />
                        <Route path="images" element={<ProtectedRoute><AddImage /></ProtectedRoute>} />
                        <Route path="voices" element={<ProtectedRoute><VoiceTranscription /></ProtectedRoute>} />
                        <Route path="knowledge" element={<ProtectedRoute><KnowledgeData /></ProtectedRoute>} />
                        <Route path="fact-tables" element={<ProtectedRoute><FactTablesPage /></ProtectedRoute>} />
                        <Route path="knowledge-graph" element={<ProtectedRoute><KnowledgeGraphPage /></ProtectedRoute>} />

                        {/* --- Integrations --- */}
                        <Route path="channels" element={<ProtectedRoute><Channels /></ProtectedRoute>} />
                        <Route path="channels/whatsapp" element={<ProtectedRoute><WhatsappChannel /></ProtectedRoute>} />
                        <Route path="channels/whatsapp-bulk" element={<ProtectedRoute><BulkWhatsappSenderChannel /></ProtectedRoute>} />
                        <Route path="channels/sms" element={<ProtectedRoute><SmsBotConnector /></ProtectedRoute>} />

                         {/* // Connectors */}
                        <Route path="connectors" element={<ProtectedRoute><Connectors /></ProtectedRoute>} />
                        <Route path="drives" element={<ProtectedRoute><DrivesLandingPage /></ProtectedRoute>} />
                        <Route path="connectors/gdrive" element={<ProtectedRoute><GoogleDriveConnector /></ProtectedRoute>} />
                        <Route path="connectors/google-reviews" element={<ProtectedRoute><GoogleReviewsConnector /></ProtectedRoute>} />
                        <Route path="connectors/google-reviews/analytics" element={<ProtectedRoute><ReviewsAnalytics /></ProtectedRoute>} />
                        <Route path="connectors/onedrive" element={<ProtectedRoute><OneDriveConnector /></ProtectedRoute>} />
                        <Route path="connectors/salesforce" element={<SalesforceConnector />} />
                        <Route path="connectors/instagram" element={<InstagramConnector />} />
                        <Route path="connectors/servicenow" element={<ServiceNowConnector />} />
                        <Route path="connectors/twitter" element={<TwitterConnector />} />
                        <Route path="connectors/lms" element={<LMSDashboard />} />
                        <Route path="connectors/prayer-timing" element={<ProtectedRoute><PrayerTimingConnector /></ProtectedRoute>} />

                        {/* --- CRM Routes --- */}
                        <Route path="crm-dashboard" element={<ProtectedRoute><CRMLandingPage /></ProtectedRoute>} />
                        <Route path="crm" element={<ProtectedRoute><CRMDashboard /></ProtectedRoute>} />
                        <Route path="crm/contacts" element={<ProtectedRoute><ContactsList /></ProtectedRoute>} />
                        <Route path="crm/contacts/:contactId" element={<ProtectedRoute><ContactDetail /></ProtectedRoute>} />
                        <Route path="crm/clients" element={<ProtectedRoute><AccountsList /></ProtectedRoute>} />
                        <Route path="crm/clients/:accountId" element={<ProtectedRoute><AccountDetail /></ProtectedRoute>} />
                        <Route path="crm/leads" element={<ProtectedRoute><LeadsList /></ProtectedRoute>} />
                        <Route path="crm/leads/:leadId" element={<ProtectedRoute><LeadDetail /></ProtectedRoute>} />
                        <Route path="crm/tags" element={<ProtectedRoute><TagsList /></ProtectedRoute>} />
                        <Route path="crm/service-reminders" element={<ProtectedRoute><ServiceRemindersPage /></ProtectedRoute>} />

                        {/* CRM SFA Routes */}
                        <Route path="sfa-dashboard" element={<ProtectedRoute><SFADashboard /></ProtectedRoute>} />
                        <Route path="crm/opportunities" element={<ProtectedRoute><OpportunityList /></ProtectedRoute>} />
                        <Route path="crm/opportunities/new" element={<ProtectedRoute><OpportunityForm /></ProtectedRoute>} />
                        <Route path="crm/opportunities/pipeline" element={<ProtectedRoute><OpportunityPipeline /></ProtectedRoute>} />
                        <Route path="crm/opportunities/:opportunityId" element={<ProtectedRoute><OpportunityDetail /></ProtectedRoute>} />
                        <Route path="crm/opportunities/:opportunityId/edit" element={<ProtectedRoute><OpportunityForm /></ProtectedRoute>} />
                        
                        <Route path="crm/forecast" element={<ProtectedRoute><ForecastDashboard /></ProtectedRoute>} />
                        <Route path="crm/products" element={<ProtectedRoute><ProductList /></ProtectedRoute>} />
                        <Route path="crm/categories" element={<ProtectedRoute><CategoryManagement /></ProtectedRoute>} />
                        <Route path="crm/price-books" element={<ProtectedRoute><PriceBookList /></ProtectedRoute>} />
                        
                        <Route path="crm/quotes" element={<ProtectedRoute><QuoteList /></ProtectedRoute>} />
                        <Route path="crm/quotes/new" element={<ProtectedRoute><QuoteBuilder /></ProtectedRoute>} />
                        <Route path="crm/quotes/:quoteId" element={<ProtectedRoute><QuoteDetail /></ProtectedRoute>} />
                        <Route path="crm/quotes/:quoteId/edit" element={<ProtectedRoute><QuoteBuilder /></ProtectedRoute>} />
                        
                        <Route path="crm/targets" element={<ProtectedRoute><SalesTargets /></ProtectedRoute>} />
                        <Route path="crm/teams" element={<ProtectedRoute><SalesTeams /></ProtectedRoute>} />
                        <Route path="crm/territories" element={<ProtectedRoute><TerritoryManagement /></ProtectedRoute>} />
                        <Route path="crm/analytics/lost-reasons" element={<ProtectedRoute><LostReasonAnalytics /></ProtectedRoute>} />

                        {/* CRM Finance Routes */}
                        <Route path="crm/salestransaction" element={<ProtectedRoute><SalesTransactionDashboard /></ProtectedRoute>} />
                        <Route path="crm/salestransaction/invoices" element={<ProtectedRoute><InvoiceList /></ProtectedRoute>} />
                        <Route path="crm/salestransaction/invoices/new" element={<ProtectedRoute><InvoiceForm /></ProtectedRoute>} />
                        <Route path="crm/salestransaction/invoices/:invoiceId" element={<ProtectedRoute><InvoiceDetail /></ProtectedRoute>} />
                        <Route path="crm/salestransaction/invoices/:invoiceId/edit" element={<ProtectedRoute><InvoiceForm /></ProtectedRoute>} />
                        <Route path="crm/salestransaction/payments" element={<ProtectedRoute><PaymentList /></ProtectedRoute>} />

                        {/* CRM Help Desk Routes */}
                        <Route path="crm/helpdesk" element={<ProtectedRoute><HelpDeskDashboard /></ProtectedRoute>} />
                        <Route path="helpdesk" element={<ProtectedRoute><HelpDeskDashboard /></ProtectedRoute>} />
                        <Route path="crm/helpdesk/tickets" element={<ProtectedRoute><TicketList /></ProtectedRoute>} />
                        <Route path="crm/helpdesk/tickets/:ticketId" element={<ProtectedRoute><TicketDetail /></ProtectedRoute>} />
                        <Route path="crm/helpdesk/ticket-categories" element={<ProtectedRoute><TicketCategoryList /></ProtectedRoute>} />
                        <Route path="crm/helpdesk/sla-policies" element={<ProtectedRoute><SLAPolicyList /></ProtectedRoute>} />
                        <Route path="crm/helpdesk/knowledge-base" element={<ProtectedRoute><KnowledgeBase /></ProtectedRoute>} />

                        {/* --- CRM Activity & Communication Routes --- */}
                        <Route path="activity-dashboard" element={<ProtectedRoute><ActivityCommDashboard /></ProtectedRoute>} />
                        <Route path="crm/activity" element={<ProtectedRoute><ActivityCommDashboard /></ProtectedRoute>} />
                        <Route path="crm/activity/tasks" element={<ProtectedRoute><TaskList /></ProtectedRoute>} />
                        <Route path="crm/activity/tasks/:taskId" element={<ProtectedRoute><TaskDetail /></ProtectedRoute>} />
                        <Route path="crm/activity/my-tasks" element={<ProtectedRoute><MyTasks /></ProtectedRoute>} />
                        <Route path="crm/activity/calendar" element={<ProtectedRoute><CalendarView /></ProtectedRoute>} />
                        <Route path="crm/activity/calendar/connections" element={<ProtectedRoute><CalendarConnections /></ProtectedRoute>} />
                        <Route path="crm/activity/booking-pages" element={<ProtectedRoute><BookingPageList /></ProtectedRoute>} />
                        <Route path="crm/activity/booking-pages/new" element={<ProtectedRoute><BookingPageForm /></ProtectedRoute>} />
                        <Route path="crm/activity/booking-pages/:pageId/edit" element={<ProtectedRoute><BookingPageForm /></ProtectedRoute>} />
                        <Route path="crm/activity/email-sync" element={<ProtectedRoute><EmailSyncSettings /></ProtectedRoute>} />
                        <Route path="crm/activity/communications" element={<ProtectedRoute><CommunicationLog /></ProtectedRoute>} />

                        {/* CRM Workflow Routes */}
                        <Route path="crm/activity/workflows" element={<ProtectedRoute><WorkflowList /></ProtectedRoute>} />
                        <Route path="crm/activity/workflows/new" element={<ProtectedRoute><WorkflowForm /></ProtectedRoute>} />
                        <Route path="crm/activity/workflows/:workflowId" element={<ProtectedRoute><WorkflowDetail /></ProtectedRoute>} />
                        <Route path="crm/activity/workflows/:workflowId/edit" element={<ProtectedRoute><WorkflowForm /></ProtectedRoute>} />

                        {/* --- HRM Routes --- */}
                        <Route path="hrm-dashboard" element={<ProtectedRoute><HRMLandingPage /></ProtectedRoute>} />
                        <Route path="hrm" element={<ProtectedRoute><HRMDashboard /></ProtectedRoute>} />
                        <Route path="hrm/employees" element={<ProtectedRoute><EmployeeList /></ProtectedRoute>} />
                        <Route path="hrm/employees/:employeeId" element={<ProtectedRoute><EmployeeDetail /></ProtectedRoute>} />
                        <Route path="hrm/departments" element={<ProtectedRoute><DepartmentList /></ProtectedRoute>} />
                        <Route path="hrm/positions" element={<ProtectedRoute><PositionList /></ProtectedRoute>} />
                        <Route path="hrm/lifecycle" element={<ProtectedRoute><EmployeeLifecycle /></ProtectedRoute>} />

                        {/* HRM Recruitment Routes */}
                        <Route path="hrm/recruitment" element={<ProtectedRoute><RecruitmentDashboard /></ProtectedRoute>} />
                        <Route path="hrm/jobs" element={<ProtectedRoute><JobList /></ProtectedRoute>} />
                        <Route path="hrm/jobs/:jobId" element={<ProtectedRoute><JobDetail /></ProtectedRoute>} />
                        <Route path="hrm/applicants" element={<ProtectedRoute><ApplicantList /></ProtectedRoute>} />
                        <Route path="hrm/applicants/:applicantId" element={<ProtectedRoute><ApplicantDetail /></ProtectedRoute>} />
                        <Route path="hrm/interviews" element={<ProtectedRoute><InterviewList /></ProtectedRoute>} />
                        <Route path="hrm/offers" element={<ProtectedRoute><OfferList /></ProtectedRoute>} />

                        <Route path="agents/productivity" element={<ProtectedRoute><Agents /></ProtectedRoute>} />
                        <Route path="agents/productivity/google-calendar" element={<ProtectedRoute><GoogleCalendarAgents /></ProtectedRoute>} />
                        <Route path="agents/productivity/mysql" element={<ProtectedRoute><MySqlAgents /></ProtectedRoute>} />
                        <Route path="agents/productivity/gmail-email" element={<ProtectedRoute><GmailEmailAgent /></ProtectedRoute>} />
                        <Route path="agents/productivity/outlook-email" element={<ProtectedRoute><OutlookEmailAgent /></ProtectedRoute>} />
                        <Route path="agents/agent-space" element={<ProtectedRoute><AgentSpace /></ProtectedRoute>} />
                        {/* Legacy alias so old bookmarks / nav entries still resolve. */}
                        <Route path="agents/agent-space" element={<ProtectedRoute><AgentSpace /></ProtectedRoute>} />

                       
                        {/* --- Marketing --- */}
                        <Route path="campaigns" element={<ProtectedRoute><Campaigns /></ProtectedRoute>} />
                        <Route path="campaigns/Gmail" element={<ProtectedRoute><GmailConnector /></ProtectedRoute>} />
                        <Route path="campaigns/Outlook" element={<OutlookConnector />} />
                        <Route path="campaigns/Sms" element={<SmsManagement />} />
                        <Route path="campaigns/Lead" element={<LeadConnector />} />

                        {/* --- SurveyGenie Routes --- */}
                        <Route path="surveys" element={<SurveyDashboard />} />
                        <Route path="surveys/builder/:surveyId" element={<SurveyBuilder />} />
                        <Route path="surveys/responses/:surveyId" element={<SurveyResponses />} />
                        <Route path="surveys/analytics/:surveyId" element={<SurveyAnalytics />} />
                        <Route path="surveys/distribution/:surveyId" element={<SurveyDistribution />} />
                        <Route path="surveys/question-bank" element={<QuestionBank />} />
                        <Route path="surveys/panelists" element={<PanelistManagement />} />
                        <Route path="surveys/distribute/email/:surveyId" element={<SurveyEmailWizard />} />
                        <Route path="surveys/text-analysis/:surveyId" element={<SurveyTextAnalysis />} />
                        <Route path="surveys/cleaning/:surveyId" element={<DataCleaningDashboard />} />
                        <Route path="surveys/cleaning/rules/:surveyId" element={<CleaningRulesBuilder />} />
                        <Route path="surveys/distribute/sms/:surveyId" element={<SurveySmsWizard />} />
                        <Route path="surveys/documents/:surveyId" element={<SurveyDocuments />} />
                        <Route path="surveys/faqs/:surveyId" element={<SurveyFAQs />} />


                        <Route path="lms">
                            <Route index element={<LMSDashboard />} />

                            {/* Courses */}
                            <Route path="courses/:courseId">
                                <Route path="builder" element={<CourseBuilder />} />
                                <Route path="enrollments" element={<CourseEnrollments />} />
                                <Route path="preview" element={<CoursePreview />} />

                                {/* Tests */}
                                <Route path="modules/:moduleId/test-builder" element={<TestBuilder />} />
                            </Route>

                            {/* Students */}
                            <Route path="students">
                                <Route index element={<StudentList />} />
                                <Route path="import" element={<StudentImport />} />
                                <Route path=":studentId" element={<StudentDetail />} />
                                <Route path=":studentId/enrollments" element={<StudentEnrollments />} />

                            </Route>

                            <Route path="embed-pages">
                                <Route index element={<LMSEmbedPages />} />
                            </Route>

                            {/* Enrollments */}
                            <Route path="enrollments">
                                <Route index element={<EnrollmentList />} />
                                <Route path=":enrollmentId/progress" element={<EnrollmentProgress />} />

                            </Route>

                            {/* Analytics */}
                            <Route path="analytics">
                                <Route index element={<LMSAnalytics />} />
                                <Route path="courses/:courseId" element={<CourseAnalytics />} />
                            </Route>

                            {/* Test Results */}
                            <Route path="test-results/:moduleId" element={<TestResults />} />

                            {/* Gamification */}
                            <Route path="gamification">
                                <Route path="points" element={<PointsConfig />} />
                                <Route path="badges" element={<BadgeManagement />} />
                            </Route>

                            <Route path="leaderboard" element={<Leaderboard />} />

                            {/* Invitations */}
                            <Route path="invitations" element={<CourseInvitations />} />
                        </Route>

                        {/* --- Volunteer Management Routes --- */}
                        <Route path="campaigns/volunteers" element={<ProtectedRoute><VolunteerManagement /></ProtectedRoute>} />
                        <Route path="campaigns/events" element={<ProtectedRoute><EventManagement /></ProtectedRoute>} />
                        <Route path="campaigns/campaign/:eventId" element={<ProtectedRoute><OutreachCampaignWizard /></ProtectedRoute>} />
                        <Route path="campaigns/event-volunteers" element={<ProtectedRoute><EventVolunteers /></ProtectedRoute>} />
                        <Route path="campaigns/outreach/:eventId" element={<ProtectedRoute><OutreachDistribution /></ProtectedRoute>} />
                        <Route path="campaigns/outreach/email/:eventId" element={<ProtectedRoute><OutreachEmailWizard /></ProtectedRoute>} />
                        <Route path="campaigns/outreach/sms/:eventId" element={<ProtectedRoute><OutreachSmsWizard /></ProtectedRoute>} />
                        <Route path="campaigns/events/calendar" element={<ProtectedRoute><EventCalendarView /></ProtectedRoute>} />
                        <Route path="campaigns/events/training" element={<ProtectedRoute><EventTraining /></ProtectedRoute>} />

                        {/* --- Event Post Management Routes --- */}
                        <Route path="campaigns/event-posts" element={<ProtectedRoute><EventPostManagement /></ProtectedRoute>} />
                        <Route path="campaigns/event-posts/new" element={<ProtectedRoute><EventPostEditor /></ProtectedRoute>} />
                        <Route path="campaigns/event-posts/:postId/edit" element={<ProtectedRoute><EventPostEditor /></ProtectedRoute>} />
                        <Route path="campaigns/event-posts/categories" element={<ProtectedRoute><EventPostCategories /></ProtectedRoute>} />
                        <Route path="campaigns/event-posts/api-help" element={<ProtectedRoute><EventPostAPIHelp /></ProtectedRoute>} />

                        <Route path="advertisements" element={<ProtectedRoute><ListMonetize /></ProtectedRoute>} />
                        <Route path="marketplace-settings" element={<ProtectedRoute><MarketplaceSettings /></ProtectedRoute>} />
                        <Route path="consented-contacts" element={<ListConsentedContacts />} />
                    
                        {/* --- Chat Space --- */}
                        <Route path="chat-space" element={<ProtectedRoute><ChatSpace /></ProtectedRoute>} />
                        <Route path="chat-space/distribute" element={<ProtectedRoute><ChatSpaceDistribute /></ProtectedRoute>} />

                        {/* --- Tracking --- */}
                        <Route path="chat-analysis" element={<ProtectedRoute><ChatAnalysis /></ProtectedRoute>} />
                        <Route path="feedbacks" element={<ProtectedRoute><ListUserFeedback /></ProtectedRoute>} />
                        <Route path="analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
                        
                        {/* --- Improvements & Settings --- */}
                        <Route path="question-improvements" element={<ProtectedRoute><ImproveQuestions /></ProtectedRoute>} />
                        <Route path="answers-improvements" element={<ProtectedRoute><ImproveAnswer /></ProtectedRoute>} />
                        <Route path="pronouns" element={<ProtectedRoute><Pronoun /></ProtectedRoute>} />
                        <Route path="summarization-settings" element={<ProtectedRoute><SummarizationSettings /></ProtectedRoute>} />
                        <Route path="settings/term-and-use" element={<ProtectedRoute><TermsManagement /></ProtectedRoute>} />

                        


                        <Route path="payments" element={<ProtectedRoute><PaymentsPage /></ProtectedRoute>} />
                    
                    </Route>

                    {/* Fallback for any unmatched authenticated route */}
                    <Route path="*" element={<Navigate to="/chatbots" replace />} />
                </Route>
            ) : (
                <Route path="*" element={<Navigate to="/Login" replace />} />
            )}
        </Routes>
    );
}

export default App;